import { HubBikeModel, VehicleType } from '../utils/Models';
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { Colors } from '../../config/Constants';
import { Box, Switch } from '@mui/material';
import { ArrowForwardIos, Star } from '@mui/icons-material';

// Booking grid component
export function BikesTable(props: {
  bikesList: HubBikeModel[],
  setParentState: any,
  containerClass: any,
  setBikeActive: (bikeId: number, newState: boolean) => any
}) {
  const dgProps = {
    disableColumnMenu: true,
    disableColumnFilter: true,
    className: 'gbk-dg',
    rowHeight: 50,
    pageSize: 10,
    columns: [{
      field: 'name',
      headerName: 'Vehicle Name',
      width: 400,
      align: 'center',
      renderCell: (o: { row: HubBikeModel }) => (
        <span>
          <div className='gbk-dg-image-text'>
            {o.row.bike?.brand} {o.row.bike?.name}
            {o.row.bike?.vehicleType === VehicleType.CAR ? ` (${o.row.bike.engineType.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, c => c.toUpperCase())})` : ''}
            {o.row.bike?.vehicleType === VehicleType.CAR && o.row.bike.transmission ? ` (${o.row.bike.transmission.charAt(0).toUpperCase() + o.row.bike.transmission.substring(1).toLowerCase()})` : ''}
          </div>&nbsp;&nbsp;<img className='gbk-dg-image' alt='bike' src={o.row.bike?.image} />
        </span>
      ),
      sortable: false,
      valueGetter: (o: { row: HubBikeModel }) => (`${o.row.bike?.brand} ${o.row.bike?.name}`)
    }, {
      field: 'quantity',
      headerName: 'Quantity',
      width: 150,
      align: 'center',
      sortable: false
    }, {
      field: 'review',
      headerName: 'Rating',
      width: 100,
      align: 'center',
      sortable: false,
      renderCell: (o: { row: HubBikeModel }) => (
        o.row.dynamicRating && o.row.dynamicRatingCount ? (
          <span> <Star /> {o.row.dynamicRating} ({o.row.dynamicRatingCount})</span>
        ) : '-'
      )
    }, {
      field: 'actions',
      headerName: 'Details',
      width: 110,
      align: 'center',
      renderCell: o => (
        <div
          style={{ color: Colors.primary, cursor: 'pointer' }}
          onClick={() => props.setParentState({ error: '', loading: false, view: 'individual', bikeData: o.row })}>
          View Details
        </div>
      ),
      sortable: false
    }, {
      field: 'active',
      headerName: 'Active',
      width: 110,
      align: 'center',
      renderCell: (o: { row: HubBikeModel }) => (
        <Switch checked={o.row.vendorActive && o.row.adminActive} onChange={(_, newState) => { props.setBikeActive(o.row.bikeId as number, newState) }} />
      ),
      sortable: false
    }] as GridColumns
  }

  return <div className={props.containerClass}>
    {/* PC Grid */}
    <DataGrid
      sx={{ display: { xs: 'none', md: 'flex' } }}
      initialState={{
        sorting: {
          sortModel: [{ field: 'name', sort: 'asc' }]
        }
      }}
      disableColumnMenu={dgProps.disableColumnMenu}
      disableColumnFilter={dgProps.disableColumnFilter}
      className={dgProps.className}
      rowHeight={dgProps.rowHeight}
      rows={props.bikesList || []}
      columns={dgProps.columns}
      pageSize={dgProps.pageSize}
      rowsPerPageOptions={[dgProps.pageSize]}
      disableSelectionOnClick
    />
    {/* Phone Grid */}
    <DataGrid
      sx={{ display: { xs: 'flex', md: 'none' } }}
      disableColumnMenu={dgProps.disableColumnMenu}
      disableColumnFilter={dgProps.disableColumnFilter}
      className={`${dgProps.className} phone`}
      rowHeight={147}
      rows={props.bikesList || []}
      columns={dgProps.columns}
      pageSize={dgProps.pageSize}
      rowsPerPageOptions={[dgProps.pageSize]}
      disableSelectionOnClick
      headerHeight={0}
      components={{
        Row: (data: { row: HubBikeModel }) => (
          <Box className='gbk-dg-row-phone'>
            <Box className='gbk-dg-row-phone-header' key={1} >
              {data.row.bike?.brand} {data.row.bike?.name}
              {data.row.bike?.vehicleType === VehicleType.CAR ? ` (${data.row.bike.engineType.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, c => c.toUpperCase())})` : ''}
              {data.row.bike?.vehicleType === VehicleType.CAR && data.row.bike.transmission ? ` (${data.row.bike.transmission.charAt(0).toUpperCase() + data.row.bike.transmission.substring(1).toLowerCase()})` : ''}

              {
                data.row.dynamicRating && data.row.dynamicRatingCount ? (
                  <span className='float-right'> <span className='gbk-icon-span fs-14'><Star /></span> {data.row.dynamicRating} ({data.row.dynamicRatingCount} reviews)</span>
                ) : ''
              }
            </Box>
            <Box
              className='gbk-dg-row-phone-body'
              key={2}
              onClick={() => props.setParentState({ error: '', loading: false, view: 'individual', bikeData: data.row })}
            >

              <Box sx={{ float: 'left', verticalAlign: 'top' }}>
                <div style={{ display: 'inline-block', verticalAlign: 'top' }}>
                  <img src={data.row.bike?.image} style={{ height: '38px', width: 'auto' }} alt="bike" />
                </div>
              </Box>
              <Box sx={{ float: 'right' }} onClick={() => props.setParentState({ error: '', loading: false, view: 'individual', bikeData: data.row })} >
                <span style={{ color: Colors.primary }} className="gbk-icon-span fs-16">
                  <ArrowForwardIos />
                </span>
              </Box>
              <Box sx={{ position: 'absolute', right: '4px', bottom: '-4px' }}>
                Active: <Switch checked={data.row.vendorActive && data.row.adminActive} onChange={(_, newState) => { props.setBikeActive(data.row.bikeId as number, newState) }} />
              </Box>
              <Box sx={{ clear: 'left' }}>
                Quantity: {data.row.quantity}
              </Box>
            </Box>
          </Box>
        )
      }}
    />
  </div >
}